import { onBeforeUnmount, onMounted, ref } from 'vue';

const callbackList = ref([]);
const timeout = ref(340);

let debounceTimer;

const handler = () => {
  // callbackList
  if (debounceTimer) clearTimeout(debounceTimer);

  debounceTimer = setTimeout(() => {
    callbackList.value.forEach((cb) => {
      cb();
    });
  }, timeout.value);
};

const resizeListener = (isRemove) => {
  if (isRemove) {
    window.removeEventListener('resize', handler);
    return;
  }
  window.addEventListener('resize', handler);
};

/**
 * container use
 *
 * 注意：处理好跟 useListenResize() 的组件的生命周期关系
 *
 * 理论上每个 route 页面的容器使用 useBoardResizeEvent 里面的组件使用 useListenResize
 */
export default function useBoardResizeEvent({ debounceTimeout } = {}) {
  if (debounceTimeout) {
    timeout.value = debounceTimeout;
  }

  onBeforeUnmount(() => {
    // console.log(`🔔 clear callbackList`);
    callbackList.value = [];
    resizeListener(/*isRemove*/ true);
  });

  onMounted(() => {
    resizeListener();
  });

  return {
    // 主动触发
    triggerResize() {
      console.log(`🔔 trigger callbackList`);
      handler();
    }
  };
}

/**
 * children use
 * 
 * 注意1：需要在 unmount 的时候 cancelListner
 * 注意2：需要在父级组件 useBoardResizeEvent()
 * 
 * 例子：
 * 
 *  const { cancelListner } = useListenResize(() => {
      resizeChart();
    });
    onBeforeUnmount(() => {
      cancelListner();
    });

 * @param {function} cb resize 后触发的回调
 * @returns 
 */
export const useListenResize = (cb) => {
  if (callbackList.value.indexOf(cb) === -1) {
    callbackList.value.push(cb);
  }
  return {
    cancelListner() {
      // console.log(`🔔 remove cb from callbackList`);
      if (!callbackList.value.length) return;
      const idx = callbackList.value.indexOf(cb);
      if (idx > -1) {
        callbackList.value.splice(idx, 1);
      }
    }
  };
};
